import { Reveal } from "./Reveal";
import { SITE_CONFIG } from "@/config/siteConfig";

export const Vsl = () => {
  if (!SITE_CONFIG.founderVideoUrl) return null;

  return (
    <section id="vsl" data-testid="vsl-section" className="pt-16 md:pt-24 pb-8 md:pb-12">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="font-mono text-xs tracking-[0.35em] uppercase text-champagne text-center mb-6">
            Watch this first. 60 seconds.
          </p>
          <div className="relative aspect-video border border-champagne/40 bg-carbon overflow-hidden shadow-[0_24px_70px_rgba(61,165,221,0.18)]">
            <iframe
              src={SITE_CONFIG.founderVideoUrl}
              title="North & Noble video"
              data-testid="vsl-iframe"
              className="absolute inset-0 w-full h-full"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
